<!-- Modal Header -->
@if (modal_name) {
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer"
      (click)="minimise = !minimise"
    ></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer"></i>
  </div>
</div>
}

<!-- Modal Body -->
<div class="modal-body" [ngClass]="{ 'no-body-scroll': modal_name }" [hidden]="minimise">
  @if (showFormLoader) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}
  @if (!showFormLoader) {
<div class="form-horizontal">
    <table class="table table-bordered form-inline">
      <tbody>
        @for (row of irsF5471ScheduleGData; track $index; let i = $index) {
<tr
         
          style="padding-bottom: 0 !important"
        >
          <td style="padding-left: 5px !important">{{ row.line_no }}.</td>
          <td style="padding-left: 5px !important">
            {{ row.line_description }}
            @if (row.line_type === 'auto5') {
<span><br />{{ row.line_description1 }}</span>
}
            @if (row.line_type === 'a') {
<span><br />{{ row.line_description2 }}</span>
}
            @if (row.line_type === 'b') {
<span><br />{{ row.line_description3 }}</span>
}
            @if (row.line_type === 'check') {
<span
              ><br />
              <div class="radioBtnPosition">
                Comparable uncontrolled transaction method
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_comparable?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_comparable, $event); checkingForValidation(row, i, 'checkbox')"
                />
              </div>
              <div class="radioBtnPosition">
                Income method
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_income?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_income, $event); checkingForValidation(row, i, 'checkbox')"
                />
              </div>
              <div class="radioBtnPosition" style="margin-left: 67px">
                Acquisition price method
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_acquisition?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_acquisition, $event); checkingForValidation(row, i, 'checkbox')"
                /><br />
              </div>
              <div class="radioBtnPosition">
                Market capitalization method
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_market?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_market, $event); checkingForValidation(row, i, 'checkbox')"
                />
              </div>
              <div class="radioBtnPosition" style="margin-left: 97px">
                Residual profit split method
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_residual?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_residual, $event); checkingForValidation(row, i, 'checkbox')"
                />
              </div>
              <div class="radioBtnPosition">
                Unspecified methods
                <input
                  style="margin-left: 5px"
                  type="checkbox"
                  [checked]="row.value_unspecified?.VALUE === '1'"
                  [disabled]="row.isEditableFlag !== 'Y'"
                  (change)="onCheckboxToggle(row.value_unspecified, $event); checkingForValidation(row, i, 'checkbox')"
                />
              </div>
              @if (row.isSaveValidFlag === 'N') {
<span class="form-error-container"
                >Please check value for line {{ row.line_no }}</span
              >
}
            </span>
}
          </td>
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            <!-- Radio buttons for propertyType 13 -->
            @if (row.propertyType === '13' || row.propertyType === 13) {
<div
              class="radioBtnPosition col-md-4"
             
            >
              Yes
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'Y'"
                [name]="'line_' + row.line_no"
                [checked]="row.value && row.value[0]?.VALUE === 'Y'"
                [disabled]="row.isEditableFlag === 'N' || row.value?.[0]?.disabled"
                (change)="onRadioBtnSelection(row, i, 'Y'); checkingForValidation(row, i, 'radio')"
              />
            </div>
}
            @if (row.propertyType === '13' || row.propertyType === 13) {
<div
              class="radioBtnPosition col-md-4"
             
            >
              No
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'N'"
                [name]="'line_' + row.line_no"
                [checked]="row.value && row.value[1]?.VALUE === 'N'"
                [disabled]="row.isEditableFlag === 'N' || row.value?.[1]?.disabled"
                (change)="onRadioBtnSelection(row, i, 'N'); checkingForValidation(row, i, 'radio')"
              />
            </div>
}
            @if (showRadioError(row)) {
            <span class="form-error-container"
              >Please select Yes or No for line {{ row.line_no }}</span
            >
}
            <!-- Amount input for propertyType 7 -->
            @if (row.propertyType === '7' || row.propertyType === 7) {
<div>
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="row.isEditableFlag === 'N'"
                [(ngModel)]="row.value.VALUE"
                (ngModelChange)="checkingForValidation(row, i, 'amount')"
              />
              @if (row.isSaveValidFlag === 'N') {
<span class="form-error-container"
                >Please check value for line {{ row.line_no }}</span
              >
}
            </div>
}
            <!-- Auto5 input -->
            @if (row.line_type === 'auto5') {
<div>
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="row.isEditableFlagText !== 'Y' || auto5"
                [(ngModel)]="row.value_1.VALUE"
                (ngModelChange)="checkingForValidation(row, i, 'amount')"
              />
              @if (row.isSaveValidFlag === 'N') {
<span class="form-error-container"
                >Please check value for line {{ row.line_no }}</span
              >
}
            </div>
}
            <!-- Type a input -->
            @if (row.line_type === 'a') {
<div>
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="row.isEditableFlagText !== 'Y'"
                [(ngModel)]="row.value_2.VALUE"
                (ngModelChange)="checkingForValidation(row, i, 'amount')"
              />
              @if (row.isSaveValidFlag === 'N') {
<span class="form-error-container"
                >Please check value for line {{ row.line_no }}</span
              >
}
            </div>
}
            <!-- Type b input -->
            @if (row.line_type === 'b') {
<div>
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="row.isEditableFlagText !== 'Y'"
                [(ngModel)]="row.value_3.VALUE"
                (ngModelChange)="checkingForValidation(row, i, 'amount')"
              />
              @if (row.isSaveValidFlag === 'N') {
<span class="form-error-container"
                >Please check value for line {{ row.line_no }}</span
              >
}
            </div>
}
          </td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>

<!-- Modal Footer -->
@if (modal_name) {
<div class="modal-footer" [hidden]="minimise">
  <button
    class="btn btn-info btn-sm save-button"
    type="button"
    (click)="saveScheduleGForm()"
    [disabled]="crudLoading"
  >
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">
    Cancel
  </button>
</div>
}
